export default {
   RULE: {
      PASSWORD_INVALID: {
         en: 'Password should at least 8 characters',
         in: 'Kata sandi harus paling sedikit 8 karakter'
      },
      TEXT_EMPTY: {
         en: 'Please input something',
         in: 'Tolong diisi'
      },
      EMAIL_INVALID: {
         en: 'Pelase input a correct email format',
         in: 'Tolong memasukkan format email yang benar'
      }
   }
   
}